import { MenuItem, TextField, MenuProps } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";

import {
  DropdownFieldProps,
  FormikContextProps
} from "../../../../types/common/form";
import styles from "./styles.module.css";

const DropdownField = ({
  name,
  label,
  dropDownList,
  itemFieldValue,
  itemFieldLabel,
  size = "small",
  ...rest
}: DropdownFieldProps) => {
  const { touched, errors, handleBlur }: FormikContextProps =
    useFormikContext<FormikValues>();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps: Partial<MenuProps> = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <>
      <TextField
        label={label}
        variant="filled"
        name={name}
        InputProps={{ 
          disableUnderline: true,
        }}
        className={`${styles.textFieldStyle} ${styles.selectDropdown}`}
        select
        error={touched?.[name] && !!errors?.[name]}
        onBlur={handleBlur}
        helperText={touched?.[name] && errors?.[name]}
        SelectProps={{
          MenuProps: MenuProps
        }}
        {...rest}
      >
        {dropDownList.map((item: any) => (
          <MenuItem
            {...item}
            value={item?.[itemFieldValue]}
            key={item?.[itemFieldValue]}
          >
            {item?.[itemFieldLabel]?.replace("_", " ")}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};

export default DropdownField;
